import assert from 'minimalistic-assert';
const swallowObserverErrors = ({ atom, logger }) => {
    assert(atom, 'expected "atom');
    assert(typeof logger?.error === 'function', 'expected logger with ".error" function');
    const observe = (observer) => atom.observe(async (...args) => {
        try {
            await observer(...args);
        }
        catch (err) {
            logger.error('Observer threw error', err);
        }
    });
    return {
        ...atom,
        observe,
    };
};
export default swallowObserverErrors;
